<div class="creation-societe-container">
  <!-- Header with progress indicator -->
  <div class="wizard-header">
    <h2 class="wizard-title">
      <i class="dx-icon dx-icon-add title-icon"></i>
      Initialisation de nouvelle société
    </h2>
    <p class="wizard-subtitle">Configurez votre nouvelle société en quelques étapes simples</p>
    
    <!-- Progress indicator -->
    <div class="progress-container">
      <dx-progress-bar 
        [value]="currentStepProgress" 
        [min]="0" 
        [max]="100" 
        class="progress-bar">
      </dx-progress-bar>
      <div class="progress-steps">
        <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
          <div class="step-number">1</div>
          <div class="step-label">Société</div>
        </div>
        <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
          <div class="step-number">2</div>
          <div class="step-label">Site principal</div>
        </div>
        <div class="step" [class.active]="currentStep === 3" [class.completed]="currentStep > 3">
          <div class="step-number">3</div>
          <div class="step-label">Configuration</div>
        </div>
        <div class="step" [class.active]="currentStep === 4">
          <div class="step-number">4</div>
          <div class="step-label">Finalisation</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main content -->
  <div class="wizard-content" *ngIf="!requeteServeurEnCours">
    
    <!-- Step 1: Société Information -->
    <div class="step-content" *ngIf="currentStep === 1">
      <div class="step-header">
        <h3>Informations de la société</h3>
        <p>Renseignez les informations principales de votre société</p>
      </div>
      
      <dx-form [formData]="societeToCreate" class="creation-form">
        <dxi-item itemType="group" caption="Informations principales" [colCount]="2">
          <dxi-item dataField="codeBo" [label]="{ text: 'Code société *' }" [colSpan]="1">
            <dxi-validation-rule type="required" message="Le code société est obligatoire"></dxi-validation-rule>
            <dxi-validation-rule type="pattern" pattern="^[A-Z0-9_-]+$" message="Le code doit contenir uniquement des lettres majuscules, chiffres, tirets et underscores"></dxi-validation-rule>
          </dxi-item>
          <dxi-item dataField="intitule" [label]="{ text: 'Nom de la société *' }" [colSpan]="1">
            <dxi-validation-rule type="required" message="Le nom de la société est obligatoire"></dxi-validation-rule>
            <dxi-validation-rule type="stringLength" [min]="2" message="Le nom doit contenir au moins 2 caractères"></dxi-validation-rule>
          </dxi-item>
          <dxi-item dataField="raisonSociale" [label]="{ text: 'Raison sociale' }" [colSpan]="2">
          </dxi-item>
        </dxi-item>
        
        <dxi-item itemType="group" caption="Adresse" [colCount]="2">
          <dxi-item dataField="adresse1" [label]="{ text: 'Adresse ligne 1' }" [colSpan]="2">
          </dxi-item>
          <dxi-item dataField="adresse2" [label]="{ text: 'Adresse ligne 2' }" [colSpan]="2">
          </dxi-item>
          <dxi-item dataField="codePostal" [label]="{ text: 'Code postal' }" [colSpan]="1">
            <dxi-validation-rule type="pattern" pattern="^\d{5}$" message="Le code postal doit contenir 5 chiffres"></dxi-validation-rule>
          </dxi-item>
          <dxi-item dataField="ville" [label]="{ text: 'Ville' }" [colSpan]="1">
          </dxi-item>
          <dxi-item dataField="pays" [label]="{ text: 'Pays' }" [colSpan]="1">
          </dxi-item>
        </dxi-item>
        
        <dxi-item itemType="group" caption="Contact" [colCount]="2">
          <dxi-item dataField="email" [label]="{ text: 'Email' }" [colSpan]="1">
            <dxi-validation-rule type="email" message="Format d'email invalide"></dxi-validation-rule>
          </dxi-item>
          <dxi-item dataField="telephone1" [label]="{ text: 'Téléphone principal' }" [colSpan]="1">
          </dxi-item>
          <dxi-item dataField="telephone2" [label]="{ text: 'Téléphone secondaire' }" [colSpan]="1">
          </dxi-item>
          <dxi-item dataField="fax" [label]="{ text: 'Fax' }" [colSpan]="1">
          </dxi-item>
        </dxi-item>
        
        <dxi-item itemType="group" caption="Informations légales" [colCount]="2">
          <dxi-item dataField="identifiantFiscal" [label]="{ text: 'Identifiant fiscal' }" [colSpan]="1">
            <dxi-validation-rule type="stringLength" max="20" message="L'identifiant fiscal ne peut pas dépasser 20 caractères"></dxi-validation-rule>
            <dxi-validation-rule type="pattern" pattern="^[A-Z0-9\-\.]*$" message="L'identifiant fiscal ne peut contenir que des lettres, chiffres, tirets et points"></dxi-validation-rule>
          </dxi-item>
        </dxi-item>
      </dx-form>
      
      <div class="help-text">
        <i class="dx-icon dx-icon-info help-icon"></i>
        <span>Le code société doit être unique et ne pourra plus être modifié après la création.</span>
      </div>
    </div>

    <!-- Step 2: Site Information -->
    <div class="step-content" *ngIf="currentStep === 2">
      <div class="step-header">
        <h3>Site principal</h3>
        <p>Configurez votre premier site (obligatoire)</p>
      </div>
      
      <dx-form [formData]="societeToCreate" class="creation-form">
        <dxi-item itemType="group" caption="Site principal" [colCount]="2">
          <dxi-item dataField="siteCodeBo" [label]="{ text: 'Code site *' }" [colSpan]="1">
            <dxi-validation-rule type="required" message="Le code site est obligatoire"></dxi-validation-rule>
            <dxi-validation-rule type="pattern" pattern="^[A-Z0-9_-]+$" message="Le code doit contenir uniquement des lettres majuscules, chiffres, tirets et underscores"></dxi-validation-rule>
          </dxi-item>
          <dxi-item dataField="siteIntitule" [label]="{ text: 'Nom du site *' }" [colSpan]="1">
            <dxi-validation-rule type="required" message="Le nom du site est obligatoire"></dxi-validation-rule>
            <dxi-validation-rule type="stringLength" [min]="2" message="Le nom doit contenir au moins 2 caractères"></dxi-validation-rule>
          </dxi-item>
        </dxi-item>
      </dx-form>
      
      <div class="help-text">
        <i class="dx-icon dx-icon-info help-icon"></i>
        <span>Chaque société doit avoir au minimum un site. Vous pourrez créer d'autres sites plus tard.</span>
      </div>
    </div>

    <!-- Step 3: Basic Configuration -->
    <div class="step-content" *ngIf="currentStep === 3">
      <div class="step-header">
        <h3>Configuration de base</h3>
        <p>Définissez les paramètres essentiels de votre société</p>
      </div>
      
      <dx-form [formData]="societeToCreate" class="creation-form">
        <dxi-item itemType="group" caption="Paramètres généraux" [colCount]="1">
          <dxi-item dataField="enabled" editorType="dxCheckBox" 
                    [label]="{visible: false}" 
                    [editorOptions]="{text: 'Société active'}">
          </dxi-item>
          <dxi-item dataField="gestionStock" editorType="dxCheckBox" 
                    [label]="{visible: false}" 
                    [editorOptions]="{text: 'Activer la gestion de stock'}">
          </dxi-item>
          <dxi-item dataField="fretLocalActif" editorType="dxCheckBox" 
                    [label]="{visible: false}" 
                    [editorOptions]="{text: 'Activer le fret local'}">
          </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" caption="Comptabilité (optionnel)" [colCount]="1">
          <dxi-item dataField="interfaceComptableActive" editorType="dxCheckBox" 
                    [label]="{visible: false}" 
                    [editorOptions]="{text: 'Activer l\'interface comptable'}">
          </dxi-item>
        </dxi-item>
      </dx-form>
      
      <div class="help-text">
        <i class="dx-icon dx-icon-info help-icon"></i>
        <span>Ces paramètres peuvent être modifiés ultérieurement dans les paramètres de la société.</span>
      </div>
    </div>

    <!-- Step 4: Summary and Creation -->
    <div class="step-content" *ngIf="currentStep === 4">
      <div class="step-header">
        <h3>Récapitulatif</h3>
        <p>Vérifiez les informations avant de créer la société</p>
      </div>
      
      <div class="summary-container">
        <dx-accordion [collapsible]="false">
          <dxi-item title="Informations société" [expanded]="true">
            <div class="summary-section">
              <div class="summary-item">
                <span class="label">Code :</span>
                <span class="value">{{ societeToCreate.codeBo }}</span>
              </div>
              <div class="summary-item">
                <span class="label">Nom :</span>
                <span class="value">{{ societeToCreate.intitule }}</span>
              </div>
              <div class="summary-item" *ngIf="societeToCreate.raisonSociale">
                <span class="label">Raison sociale :</span>
                <span class="value">{{ societeToCreate.raisonSociale }}</span>
              </div>
              <div class="summary-item" *ngIf="societeToCreate.adresse1">
                <span class="label">Adresse :</span>
                <span class="value">{{ societeToCreate.adresse1 }}</span>
              </div>
              <div class="summary-item" *ngIf="societeToCreate.adresse2">
                <span class="label">Adresse ligne 2 :</span>
                <span class="value">{{ societeToCreate.adresse2 }}</span>
              </div>
              <div class="summary-item" *ngIf="societeToCreate.codePostal || societeToCreate.ville">
                <span class="label">Localisation :</span>
                <span class="value">{{ societeToCreate.codePostal }} {{ societeToCreate.ville }}</span>
              </div>
              <div class="summary-item" *ngIf="societeToCreate.pays">
                <span class="label">Pays :</span>
                <span class="value">{{ societeToCreate.pays }}</span>
              </div>
              <div class="summary-item" *ngIf="societeToCreate.email">
                <span class="label">Email :</span>
                <span class="value">{{ societeToCreate.email }}</span>
              </div>
              <div class="summary-item" *ngIf="societeToCreate.telephone1">
                <span class="label">Téléphone :</span>
                <span class="value">{{ societeToCreate.telephone1 }}</span>
              </div>
              <div class="summary-item" *ngIf="societeToCreate.identifiantFiscal">
                <span class="label">Identifiant fiscal :</span>
                <span class="value">{{ societeToCreate.identifiantFiscal }}</span>
              </div>
            </div>
          </dxi-item>
          <dxi-item title="Site principal" [expanded]="true">
            <div class="summary-section">
              <div class="summary-item">
                <span class="label">Code site :</span>
                <span class="value">{{ societeToCreate.siteCodeBo }}</span>
              </div>
              <div class="summary-item">
                <span class="label">Nom du site :</span>
                <span class="value">{{ societeToCreate.siteIntitule }}</span>
              </div>
            </div>
          </dxi-item>
          <dxi-item title="Configuration" [expanded]="true">
            <div class="summary-section">
              <div class="summary-item">
                <span class="label">Société active :</span>
                <span class="value">{{ societeToCreate.enabled ? 'Oui' : 'Non' }}</span>
              </div>
              <div class="summary-item">
                <span class="label">Gestion de stock :</span>
                <span class="value">{{ societeToCreate.gestionStock ? 'Activée' : 'Désactivée' }}</span>
              </div>
              <div class="summary-item">
                <span class="label">Fret local :</span>
                <span class="value">{{ societeToCreate.fretLocalActif ? 'Activé' : 'Désactivé' }}</span>
              </div>
              <div class="summary-item">
                <span class="label">Interface comptable :</span>
                <span class="value">{{ societeToCreate.interfaceComptableActive ? 'Activée' : 'Désactivée' }}</span>
              </div>
            </div>
          </dxi-item>
        </dx-accordion>
      </div>
      
      <div class="warning-text">
        <i class="dx-icon dx-icon-warning warning-icon"></i>
        <span>Une fois initialisée, certaines informations comme le code société ne pourront plus être modifiées.</span>
      </div>
    </div>
  </div>

  <!-- Navigation buttons -->
  <div class="wizard-navigation" *ngIf="!requeteServeurEnCours">
    <dx-button 
      text="Précédent" 
      type="normal" 
      stylingMode="outlined"
      [disabled]="currentStep === 1"
      (onClick)="previousStep()"
      class="nav-button">
    </dx-button>
    
    <div class="nav-right">
      <dx-button 
        *ngIf="currentStep < 4"
        text="Suivant" 
        type="default" 
        stylingMode="contained"
        [disabled]="!canProceedToNextStep()"
        (onClick)="nextStep()"
        class="nav-button">
      </dx-button>
      
      <dx-button 
        *ngIf="currentStep === 4"
        text="Initialiser la société" 
        type="success" 
        stylingMode="contained"
        [disabled]="!canCreateSociete()"
        (onClick)="creer()"
        class="nav-button create-button">
        <i class="dx-icon dx-icon-check button-icon"></i>
      </dx-button>
    </div>
  </div>

  <!-- Loading state -->
  <div class="loading-container" *ngIf="requeteServeurEnCours">
    <dx-load-indicator [visible]="requeteServeurEnCours" height="80" width="80"></dx-load-indicator>
    <p class="loading-text">Initialisation de la société en cours...</p>
    <p class="loading-subtext">Veuillez patienter, cette opération peut prendre quelques instants.</p>
  </div>
</div>
